import { Button, Input, Segmented, Select } from 'antd';

import { IconCSV } from '@assets';

import { AccessMapFilters, AccessMapView, AdminRole } from './aggregate';
import * as S from './styled';

type Props = {
  view: AccessMapView;
  filters: AccessMapFilters;
  exportDisabled: boolean;
  onViewChange: (view: AccessMapView) => void;
  onFiltersChange: (filters: AccessMapFilters) => void;
  onExport: () => void;
};

const ROLE_OPTIONS: Array<{ label: string; value: AdminRole }> = [
  { label: 'Admin', value: 'admin' },
  { label: 'Accountant', value: 'accountant' },
  { label: 'KYC', value: 'kyc' },
  { label: 'Support', value: 'support' },
];

const AccessMapToolbar = ({
  view,
  filters,
  exportDisabled,
  onViewChange,
  onFiltersChange,
  onExport,
}: Props) => (
  <S.Toolbar align="center" justify="space-between" gap={16} wrap="wrap">
    <Segmented<AccessMapView>
      value={view}
      onChange={onViewChange}
      options={[
        { label: 'By employee', value: 'employee' },
        { label: 'By company', value: 'company' },
      ]}
    />

    <S.Toolbar align="center" justify="flex-end" gap={12} wrap="wrap">
      <Input.Search
        allowClear
        placeholder="Search employee or company"
        style={{ width: 260 }}
        value={filters.term}
        onChange={(event) =>
          onFiltersChange({ ...filters, term: event.target.value })
        }
      />
      <Select<AdminRole | undefined>
        allowClear
        placeholder="All roles"
        style={{ width: 160 }}
        value={filters.role}
        options={ROLE_OPTIONS}
        onChange={(role) => onFiltersChange({ ...filters, role })}
      />
      <Button
        icon={<IconCSV />}
        onClick={onExport}
        disabled={exportDisabled}
      >
        Export CSV
      </Button>
    </S.Toolbar>
  </S.Toolbar>
);

export default AccessMapToolbar;
